var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgMainmenu5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "crossover 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 652",
    d: "M52.9802 30.7627L89.4915 30.7627V46.6102H38.2203L52.9802 30.7627Z",
    fill: "#95C9F8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1456",
    cx: 34.0254,
    cy: 72.2458,
    r: 7.92373,
    fill: "#FFCE26"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1457",
    cx: 81.5678,
    cy: 72.2458,
    r: 7.92373,
    fill: "#FFCE26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M96.2104 31.24H99.88C101.339 31.24 102.52 30.0586 102.52 28.6C102.52 27.1414 101.339 25.96 99.88 25.96H48.4352C46.8424 25.96 45.3046 26.6706 44.5984 27.5792L23.298 46.6752C23.1682 46.7918 23.0978 46.9458 22.9966 47.08H7.63401C4.63761 47.08 2.20001 49.5154 2.20001 52.5118V68.0328C2.20001 71.0358 4.64421 73.48 7.64501 73.48H18.3062C19.5338 79.497 24.8622 84.04 31.24 84.04C37.6178 84.04 42.9462 79.497 44.1738 73.48H65.8284C67.056 79.497 72.3844 84.04 78.7622 84.04C85.14 84.04 90.4684 79.497 91.696 73.48H102.357C105.358 73.48 107.802 71.0358 107.802 68.0328V49.423C107.802 48.3604 107.483 47.3418 106.878 46.486L96.2104 31.24ZM31.24 78.76C26.873 78.76 23.32 75.207 23.32 70.84C23.32 66.473 26.873 62.92 31.24 62.92C35.607 62.92 39.16 66.473 39.16 70.84C39.16 75.207 35.607 78.76 31.24 78.76ZM78.76 78.76C74.393 78.76 70.84 75.207 70.84 70.84C70.84 66.473 74.393 62.92 78.76 62.92C83.127 62.92 86.68 66.473 86.68 70.84C86.68 75.207 83.127 78.76 78.76 78.76ZM102.355 68.2H91.6938C90.4662 62.183 85.1378 57.64 78.76 57.64C72.3822 57.64 67.0538 62.183 65.8262 68.2H44.1716C42.944 62.183 37.6156 57.64 31.2378 57.64C24.86 57.64 19.5492 62.1676 18.3106 68.1692L7.47781 68.0306V62.9178H15.3978C16.8564 62.9178 18.0378 61.7364 18.0378 60.2778C18.0378 58.8192 16.8564 57.6378 15.3978 57.6378H7.47781L7.63181 52.3578H84.0378C85.4964 52.3578 86.6778 51.1764 86.6778 49.7178C86.6778 48.2592 85.4964 47.0778 84.0378 47.0778H81.3978V39.1578C81.3978 37.6992 80.2164 36.5178 78.7578 36.5178C77.2992 36.5178 76.1178 37.6992 76.1178 39.1578V47.0778H60.2778V39.1578C60.2778 37.6992 59.0964 36.5178 57.6378 36.5178C56.1792 36.5178 54.9978 37.6992 54.9978 39.1578V47.0778H30.756L48.433 31.2378L89.9976 31.5502L102.518 49.4208L102.353 68.1978L102.355 68.2Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16 11.8824C16 6.424 20.4767 2 26 2C31.5233 2 36 6.424 36 11.8824C36 18.4706 26 30 26 30C26 30 16 18.4706 16 11.8824Z",
    fill: "#FFCE26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26 15C24.3425 15 23 13.6575 23 12C23 10.3425 24.3425 9 26 9C27.6575 9 29 10.3425 29 12C29 13.6575 27.6575 15 26 15Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgMainmenu5);
export default __webpack_public_path__ + "static/media/img-mainmenu-5.56ee6724ae5386e8cac4c491489ff3de.svg";
export { ForwardRef as ReactComponent };